var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32382_67859)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.3335C11.6821 1.3335 14.6668 4.31827 14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31827 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31827 4.31827 1.3335 8.00016 1.3335Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0338 8.31122C9.54776 8.83522 8.22509 9.72189 7.54843 10.0066C7.44043 10.0519 7.16509 10.1479 7.10576 10.1492C6.97976 10.1532 6.85843 10.0826 6.79976 9.96922C6.77709 9.92522 6.71043 9.63789 6.68909 9.50989C6.62576 9.12055 6.59309 8.51589 6.59376 7.90789C6.59309 7.26989 6.62843 6.63655 6.69909 6.25122C6.71776 6.14722 6.77243 5.90789 6.78843 5.86922C6.81843 5.79722 6.87309 5.74055 6.93909 5.70522C6.98976 5.67789 7.04776 5.66322 7.10576 5.66522C7.16509 5.66655 7.40643 5.75122 7.48909 5.78389C8.14109 6.03722 9.52043 6.95589 10.0271 7.49589C10.0724 7.54455 10.1971 7.67522 10.2178 7.70189C10.2651 7.76189 10.2884 7.83455 10.2884 7.90789C10.2884 7.97589 10.2678 8.04522 10.2251 8.10322C10.2031 8.13322 10.0758 8.26655 10.0338 8.31122Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32382_67859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.d95f9be02b0f4b7ddf5e6decef33252a.svg";
export { ForwardRef as ReactComponent };